module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURTp2/zp2/0dwTDp0/zx0/zx2/zx2/zx2/ztx/zp0/zx2/zx0/zx2/xBnts8AAAAMdFJOU0DBAIE+v99+EzDxofe6mNsAAABfSURBVAjXYzgDBAzoxNIwIJEaBSSClIGEkSoKK70USISXYWoDESDQ4QAiWVxcXDoYmjRdwBIuEL1gdRBTTEGmmAEJIfUznIE5B0PBdjAp2RxQAruAM7SAWxSmQxFJLwBugVHdwb/j9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-gzh-active.png
// module id = 9W8J
// module chunks = 34